import React, { useContext } from 'react'
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { CountryDataType, useInit } from "../DataFetch/useInit";
import { Box, Button, TextField, Typography, FormControl, Select, MenuItem, FormHelperText } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { PostUpdateCountry, UpdateCountryType, PostDeleteCountry } from "../DataFetch/ManagementAPI";
import { SessionContext } from '../ManagementRoot';
import { useErrorDialog } from '../Component/useErrorDialog';
import { useConfirmDialog } from '../Component/useConfirmDialog';
import { RegionDataType } from '../DataFetch/useRegionMaster';

interface FormInputType {
    id: number,
    countryName: string,
    countryNameEn: string,
    regionId: number,
    countryCode2: string,
    countryCode3: string,
    dropdownDisp: string,
}

interface PropsType {
    editData:CountryDataType | undefined,
    CompleteEdit:() => void,
    setEditing:(editing:boolean) => void    
}

export function CountryMasterEdit({editData, CompleteEdit, setEditing}:PropsType) {

    const isNew = editData === undefined ? true : false

    const {waitConfirm, ConfirmDialog} = useConfirmDialog();

    const {openErrorDialog, ErrorDialog} = useErrorDialog();

    const ConfirmSession = useContext(SessionContext);

    const {init} = useInit();

    const {control, handleSubmit } = useForm<FormInputType>({
        defaultValues:{
            id: editData?.id,
            countryName: editData?.country_name,
            countryNameEn: editData?.country_name_en,
            regionId: editData?.region_id,
            countryCode2: editData?.country_code2,
            countryCode3: editData?.country_code3,
            dropdownDisp: editData?.dropdown_disp,
        }
    });

    async function onSubmit(inputData:FormInputType) {

        if(!await ConfirmSession()) {
            return;
        }

        const postData: UpdateCountryType = {
            countryId: Number(editData?.id),
            countryName: inputData.countryName,
            countryNameEn: inputData.countryNameEn,
            regionId: inputData.regionId,
            countryCode2: inputData.countryCode2,
            countryCode3: inputData.countryCode3,
            dropdownDisp: inputData.dropdownDisp,
            targetYear: editData?.target_year.toString(),
        }

        await waitConfirm("保存します。よろしいですか？")
        .then(res => {
            res && PostUpdateCountry(postData)
            .then(res => {
                res ? CompleteEdit() : openErrorDialog();
            })
        })
        
    }

    async function DeleteCountry() {

        if(!await ConfirmSession()) {
            return;
        }

        await waitConfirm("削除します。よろしいですか？")
        .then(res => {
            res && PostDeleteCountry(Number(editData?.id))
            .then(res => {
                res ? CompleteEdit() : openErrorDialog();
            })
        })
        
    }

    return(
        <>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Grid2 container direction="row" maxWidth="xl" justifyContent="center" alignItems="center" spacing={2}>
                    <Grid2 xs={12} sm="auto">
                        <Typography variant="body1" sx={{textAlign:{xs:"none",sm:"left"}}}>
                            {"国ID　　　　　"}
                        </Typography>  
                    </Grid2>
                    <Grid2 xs={12} sm={3}>
                        <Controller
                            name="id"
                            control={control}
                            rules={{
                                required:"必須項目です。",
                                maxLength: {
                                    value: 4,
                                    message:"4桁以下にしてください。"
                                },
                                pattern: {
                                    value: /[0-9]/,
                                    message: "数字のみ入力可能です"
                                }
                            }}
                            render={({field,fieldState}) => (
                                <TextField 
                                    fullWidth
                                    {...field} 
                                    error={fieldState.invalid}
                                    helperText={fieldState.error?.message}
                                    disabled={!isNew}
                                />
                            )}
                        />
                    </Grid2>
                </Grid2>

                <Grid2 container direction="row" maxWidth="xl" justifyContent="center" alignItems="center" spacing={2}>
                    <Grid2 xs={12} sm="auto">
                        <Typography variant="body1" sx={{textAlign:{xs:"none",sm:"left"}}}>
                            {"国名（日本語）"}
                        </Typography>  
                    </Grid2>
                    <Grid2 xs={12} sm={3}>
                        <Controller
                            name="countryName"
                            control={control}
                            rules={{
                                required:"必須項目です。",
                                maxLength: {
                                    value: 40,
                                    message:"40文字以下にしてください。"
                                }
                            }}
                            render={({field,fieldState}) => (
                                <TextField 
                                    fullWidth
                                    {...field} 
                                    error={fieldState.invalid}
                                    helperText={fieldState.error?.message}
                                />
                            )}
                        />
                    </Grid2>
                </Grid2>

                <Grid2 container direction="row" maxWidth="xl" justifyContent="center" alignItems="center" spacing={2}>
                    <Grid2 xs={12} sm="auto">
                        <Typography variant="body1" sx={{textAlign:{xs:"none",sm:"left"}}}>
                            {"国名（英語）　"}
                        </Typography>  
                    </Grid2>
                    <Grid2 xs={12} sm={3}>
                        <Controller
                            name="countryNameEn"
                            control={control}
                            rules={{
                                required:"必須項目です。",
                                maxLength: {
                                    value: 60,
                                    message:"60文字以下にしてください。"
                                }
                            }}
                            render={({field,fieldState}) => (
                                <TextField 
                                    fullWidth
                                    {...field} 
                                    error={fieldState.invalid}
                                    helperText={fieldState.error?.message}
                                />
                            )}
                        />
                    </Grid2>
                </Grid2>

                <Grid2 container direction="row" maxWidth="xl" justifyContent="center" alignItems="center" spacing={2}>
                    <Grid2 xs={12} sm="auto">
                        <Typography variant="body1" sx={{textAlign:{xs:"none",sm:"left"}}}>
                            {"地域　　　　　"}
                        </Typography>  
                    </Grid2>
                    <Grid2 xs={12} sm={3}>
                        <Controller
                            name="regionId"
                            control={control}
                            rules={{required:"必須項目です。"}}
                            render={({field,fieldState}) => (
                                <FormControl fullWidth error={fieldState.invalid}>
                                    <Select {...field} sx={{textAlign:"left"}}>
                                        {init?.region_data.map((item:RegionDataType,index:number) => (
                                            <MenuItem key={index} value={item.region_id}>{item.region_name}</MenuItem>
                                        ))}
                                    </Select>
                                    <FormHelperText>{fieldState.error?.message}</FormHelperText>
                                </FormControl>
                            )}
                        />
                    </Grid2>
                </Grid2>

                <Grid2 container direction="row" maxWidth="xl" justifyContent="center" alignItems="center" spacing={2}>
                    <Grid2 xs={12} sm="auto">
                        <Typography variant="body1" sx={{textAlign:{xs:"none",sm:"left"}}}>
                            {"国コード２桁　"}
                        </Typography>  
                    </Grid2>
                    <Grid2 xs={12} sm={3}>
                        <Controller
                            name="countryCode2"
                            control={control}
                            rules={{
                                required:"必須項目です。",
                                maxLength: {
                                    value: 2,
                                    message:"2文字にしてください。"
                                },
                                minLength: {
                                    value: 2,
                                    message:"2文字にしてください。"
                                }
                            }}
                            render={({field,fieldState}) => (
                                <TextField 
                                    fullWidth
                                    {...field} 
                                    error={fieldState.invalid}
                                    helperText={fieldState.error?.message}
                                />
                            )}
                        />
                    </Grid2>
                </Grid2>

                <Grid2 container direction="row" maxWidth="xl" justifyContent="center" alignItems="center" spacing={2}>
                    <Grid2 xs={12} sm="auto">
                        <Typography variant="body1" sx={{textAlign:{xs:"none",sm:"left"}}}>
                            {"国コード３桁　"}
                        </Typography>  
                    </Grid2>
                    <Grid2 xs={12} sm={3}>
                        <Controller
                            name="countryCode3"
                            control={control}
                            rules={{
                                required:"必須項目です。",
                                maxLength: {
                                    value: 3,
                                    message:"3文字にしてください。"
                                },
                                minLength: {
                                    value: 3,
                                    message:"3文字にしてください。"
                                }
                            }}
                            render={({field,fieldState}) => (
                                <TextField 
                                    fullWidth
                                    {...field} 
                                    error={fieldState.invalid}
                                    helperText={fieldState.error?.message}
                                />
                            )}
                        />
                    </Grid2>
                </Grid2>

                <Grid2 container direction="row" maxWidth="xl" justifyContent="center" alignItems="center" spacing={2}>
                    <Grid2 xs={12} sm="auto">
                        <Typography variant="body1" sx={{textAlign:{xs:"none",sm:"left"}}}>
                            {"応募時表示名　"}
                        </Typography>  
                    </Grid2>
                    <Grid2 xs={12} sm={3}>
                        <Controller
                            name="dropdownDisp"
                            control={control}
                            rules={{
                                required:"必須項目です。",
                                maxLength: {
                                    value: 255,
                                    message:"255文字以下にしてください。"
                                }
                            }}
                            render={({field,fieldState}) => (
                                <TextField 
                                    fullWidth
                                    {...field} 
                                    error={fieldState.invalid}
                                    helperText={fieldState.error?.message}
                                />
                            )}
                        />
                    </Grid2>
                </Grid2>

                <Box m={1}>
                    <Grid2 container direction="row" maxWidth="xl" justifyContent="center" alignItems="center" spacing={2}>
                        <Grid2>
                            <Button variant="outlined" onClick={() => setEditing(false)}>
                                戻る
                            </Button>
                        </Grid2>
                        <Grid2>
                            <Button type="submit" variant="contained">
                                保存
                            </Button>
                        </Grid2>
                        <Grid2 display={isNew ? "none" : ""}>
                            <Button variant="contained" color="error" onClick={DeleteCountry}>
                                削除
                            </Button>
                        </Grid2>                     
                    </Grid2>
                </Box>  
            </form>

            <ConfirmDialog/>
            <ErrorDialog/>
        </>
    );
}